import React, { Component } from 'react'
import Style from './style.module.less'
import { APPLICATION_LIST } from './constant'
import { observer } from 'mobx-react'
import mainStore from '@components/Main/store'
import { HLJ_STATISTIC } from '@util'

@observer
export default class extends Component {
  componentDidMount() {
    HLJ_STATISTIC({
      element_tag: 'pro_page_init'
    })
  }

  statisticApp = key => () => {
    HLJ_STATISTIC({
      element_tag: key
    })
  }

  render() {
    const { merchantInfo } = mainStore
    const { property_id } = merchantInfo || {}
    // 潜在客资转化仅限于婚纱摄影、婚礼策划类目展示；
    return (
      <div style={{ marginTop: '20px', padding: '20px' }}>
        {APPLICATION_LIST.map((item, index) => {
          return (
            <div className={Style.card} key={index}>
              <div className={Style['card-title']}>{item.title}</div>
              <div className={Style['card-desc']}>{item.desc}</div>
              {/* <Row gutter={20}> */}
              <div className={Style['app-block-list']}>
                {item.list.map((app, i) => {
                  if (
                    property_id != 6 &&
                    property_id != 2 &&
                    index == 1 &&
                    i == 4
                  ) {
                    return null
                  }

                  return (
                    // <Col span={8} key={i}>
                    <a
                      href={app.link}
                      key={i}
                      className={Style['app-block']}
                      onClick={this.statisticApp(app.key)}
                    >
                      <img className={Style['app-img']} src={app.img} />
                      <div className={Style['app-right']}>
                        <p className={Style['app-title']}>{app.title}</p>
                        <p className={Style['app-desc']}>{app.desc}</p>
                      </div>
                    </a>
                    // </Col>
                  )
                })}
              </div>
              {/* </Row> */}
            </div>
          )
        })}
      </div>
    )
  }
}
